/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGatewaysResult } from '../../models/get-gateways-result';

export interface ApiModelsGatewaysGet$Params {
}

export function apiModelsGatewaysGet(http: HttpClient, rootUrl: string, params?: ApiModelsGatewaysGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGatewaysResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsGatewaysGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGatewaysResult>;
    })
  );
}

apiModelsGatewaysGet.PATH = '/api/Models/gateways';
